<div class="main-menu">
  <div class="main-container">
    <div class="column-medium">
        <h3>Nuevos envíos</h3>
        <div class="nuevas-firmas tooltip">
          <app-custom-tooltip-sqp [textoTooltip]="getTooltip()" [posicion]="'bottom'"></app-custom-tooltip-sqp>
          <app-indicador-numero [numero]="sumaNuevos?.toString()" [color]="'var(--hs-yellow)'"></app-indicador-numero>
          <div>Nuevos envíos</div>
          <div (click)="navega('NUEVAS')">Acceder</div>
        </div>
        <app-boton-resumen-firmas [resumenEstados]="resumenInicial?.ResumenEstados"></app-boton-resumen-firmas>
    </div>
    <div class="column-big">
        <app-boton-ultimas-firmas [ultimasFirmas]="resumenInicial?.UltimasFirmas"></app-boton-ultimas-firmas>
    </div>
    <div class="column-medium">
      <h6>ACCESOS DIRECTOS</h6>
      <app-boton-acceso-directo [icono]="'#hs-send'" [titulo]="'Nuevo envío estándar'" [texto]="'Dirigido solo a empleados con documentos genéricos.'" (click)="navega('ESTANDAR')"></app-boton-acceso-directo>
      <app-boton-acceso-directo [icono]="'#hs-send-universal'" [titulo]="'Nuevo envío universal'" [texto]="'Dirigido a empleados y no empleados sin datos personales.'" (click)="navega('UNIVERSAL')"></app-boton-acceso-directo>
      <app-boton-acceso-directo [icono]="'#hs-employees'" [titulo]="'Actualizar empleados'" [texto]="'Autorellena al combinarlo con una plantilla excel de firmante.'" (click)="navega('EMPLEADOS')"></app-boton-acceso-directo>
      <h6 style="margin-top: 20px!important; margin-bottom: 5px!important;">OTROS ACCESOS</h6>
      <ul>
        <div class="li-flex">
          <li style="padding-right: 10px;" (click)="navega('INCOMPLETOS')">Dosieres incompletos</li>
          <app-indicador-numero [numero]="resumenInicial?.DosieresIncompletos.toString()" [color]="'var(--hs-red)'"></app-indicador-numero>
        </div>
        <li (click)="navega('DOCUMENTOS')">Documentos</li>
        <li><a href="https://soporte.hireandsign.com/"  target="_blank">Centro de ayuda</a></li>
      </ul>
    </div>
  </div>
</div>
